const styles = {
  paddingX: "sm:px-16 px-5",
  paddingY: "sm:py-16 py-5",
  padding: "sm:px-16 px-5 sm:py-16 py-10",

  sectionHeadTextServices:
    "text-black uppercase md:text-[60px] sm:text-[50px] xs:text-[40px] text-[30px]",
  sectionHeadText:
    "text-white uppercase md:text-[60px] sm:text-[50px] xs:text-[40px] text-[30px]",
}

export { styles }
